import React, { Fragment, useCallback, useEffect, useState } from "react";
import FeatureComponent from "../Components/Home/FeatureComponent";
import CompanyComponent from "../Components/Home/CompanyComponent";
/* feature images */
// import fresherImg from "../Assets/img/o1.png";
// import intershipImg from "../Assets/img/o2.png";
// import remoteJobImg from "../Assets/img/o3.png";
// import hotJobImg from "../Assets/img/o4.png";
// import otherJobImg from "../Assets/img/o5.png";
// import riseJobImg from "../Assets/img/o6.png";
/* company images */
//import acuity from "../Assets/img/comapny-logos/acuity.jpg";
import adobe from "../Assets/img/comapny-logos/adobe.jpg";
//import bcg from "../Assets/img/comapny-logos/bcg.jpg";
//import carelon from "../Assets/img/comapny-logos/carelon.jpg";
//import factset from "../Assets/img/comapny-logos/factset.jpg";
//import kpmg from "../Assets/img/comapny-logos/kpmg.jpg";
import {
  useGetCitiesQuery,
  useGetCompanyListQuery,
  useGetFilterOptionsQuery,
} from "../Store/api/CommonApi";
//import Swal from "sweetalert2";
import HotJobComponent from "../Components/Home/HotJobComponent";
import { Link, useNavigate } from "react-router-dom";

// const featureSection = [
//   { img: fresherImg, title: "Fresher", link: "/" },
//   { img: intershipImg, title: "Intership", link: "/" },
//   { img: remoteJobImg, title: "Remote Jobs", link: "/" },
//   { img: hotJobImg, title: "Hot Jobs", link: "/" },
//   { img: otherJobImg, title: "Other Jobs", link: "/" },
//   { img: riseJobImg, title: "RISE Job 2025", link: "/" },
// ];

// const companySection = [
//   { img: acuity, title: "acuity", link: "/" },
//   { img: adobe, title: "adobe", link: "/" },
//   { img: bcg, title: "bcg", link: "/" },
//   { img: carelon, title: "carelon", link: "/" },
//   { img: factset, title: "factset", link: "/" },
//   { img: kpmg, title: "kpmg", link: "/" },
// ];

export default function Home() {
  const [searchInput, setSearchInput] = useState({
    page: "1",
    limit: "10",
    keyword: "",
    location: "",
    experience: "",
    skill: "",
    job_types: "",
    hotjob: "",
    postdate: "",
  });
  const [companies, setCompanies] = useState([]);
  const [hotJobs, setHotJobs] = useState([]);
  const [cities, setCities] = useState([]);
  const [experiences, setExperienceOption] = useState({});
  const [path, setPath] = useState("");
  const cityApi = useGetCitiesQuery();
  const OptionApi = useGetFilterOptionsQuery();
  const { data, isError } = useGetCompanyListQuery();
  const navigate = useNavigate();

  useEffect(() => {
    var window_height = window.innerHeight,
      header_height = window.$(".default-header").height(),
      //header_height_static = window.$(".site-header.static").outerHeight(),
      fitscreen = window_height - header_height;

    window.$(".fullscreen").css("height", window_height);
    window.$(".fitscreen").css("height", fitscreen);

    //window.$("#experience").niceSelect();
    //window.$("#location").niceSelect();

    setTimeout(() => {
      window.$(".ath_carousel_se_04_carousel").owlCarousel({
        items: 7,
        nav: true,
        loop: true,

        mouseDrag: true,
        responsiveClass: true,
        navText: [
          "<i className='icofont-bubble-left'></i>",
          "<i className='icofont-bubble-right'></i>",
        ],
        responsive: {
          0: {
            items: 1,
          },
          480: {
            items: 2,
          },
          767: {
            items: 3,
          },
          992: {
            items: 3,
          },
          1200: {
            items: 5,
          },
        },
      });
    }, 1000);
  }, [data]);

  useEffect(() => {
    setCompanies(data?.data);
    setHotJobs(data?.hotjobs);
    setPath(data?.path);
  }, [data]);

  useEffect(() => {
    if (isError) {
      // Swal.fire({
      //   title: "Error!",
      //   text: "Error while feching companies.",
      //   icon: "error",
      // });
      console.log("Error while feching companies.");
    }
  }, [isError]);

  useEffect(() => {
    if (OptionApi?.data) {
      setExperienceOption(OptionApi?.data?.data?.experience);
    }
  }, [OptionApi?.data, setExperienceOption]);

  const getCities = useCallback(
    (cities) => {
      let cityArray = [];
      if (cities.length > 0) {
        for (let index = 0; index < cities.length; index++) {
          cityArray.push(
            <option value={cities[index]["id"]} key={index}>
              {cities[index]["city_name"]}
            </option>
          );
        }
        setCities(cityArray);
      }
    },
    [setCities]
  );

  const handleSearch = useCallback(
    (e) => {
      e.preventDefault();
      let location = window.$("#location").val();
      let experience = window.$("#experience").val();
      let searchData = {
        ...searchInput,
        location: location,
        experience: experience,
      };
      setSearchInput(searchData);
      const u = new URLSearchParams(searchData).toString();
      navigate(`/jobs?${u}`);
    },
    [setSearchInput, searchInput, navigate]
  );

  useEffect(() => {
    if (cityApi?.data) {
      getCities(cityApi?.data?.data);
    }
  }, [cityApi?.data, getCities]);

  return (
    <Fragment>
      {/* start banner Area */}
      <section className="banner-area relative" id="home">
        <div className="overlay overlay-bg" />
        <div className="container">
          <div className="row fullscreen d-flex align-items-center justify-content-center">
            <div className="banner-content col-lg-12">
              <h1 className="text-black">
                <span>Find</span> your dream job now
              </h1>
              <form className="serach-form-area" onSubmit={handleSearch}>
                <div className="row justify-content-center form-wrap">
                  <div className="col-lg-4 form-cols">
                    <input
                      type="text"
                      className="form-control"
                      name="search"
                      placeholder="What are you looking for?"
                      onChange={(e) =>
                        setSearchInput({
                          ...searchInput,
                          keyword: e.target.value,
                        })
                      }
                      required
                    />
                  </div>
                  <div className="col-lg-3 form-cols">
                    <div className="default-select" id="default-selects">
                      <select className="form-control" id="location">
                        <option value="" hidden>
                          Select Location
                        </option>
                        {cities}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-3 form-cols">
                    <div className="default-select" id="default-selects2">
                      <select className="form-control" id="experience">
                        <option value="" hidden>
                          Experience
                        </option>
                        {Object.keys(experiences).length > 0 &&
                          Object.keys(experiences).map((exp, i) => {
                            return (
                              <option value={exp} key={i}>
                                {experiences[exp]}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-2 form-cols">
                    <button type="submit" className="btn btn-info">
                      <span className="lnr lnr-magnifier" /> Search
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* End banner Area */}

      <section className="feature-cat-area pt-100" id="category">
        <div className="container">
          <div className="row">
            <FeatureComponent />
          </div>
        </div>
      </section>

      {/* Start feature-cat Area */}
      <section className="feature-cat-area pt-100 pb-50">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="menu-content pb-20 col-lg-10">
              <div className="title text-center">
                <h1 className="mb-10">Hot Jobs</h1>
              </div>
            </div>
          </div>
          <div className="col-md-12 px-4 pt-0">
            <div className="owl-carousel ath_carousel_se_04_carousel owl-theme">
              {hotJobs?.length > 0 &&
                hotJobs.map((job, i) => (
                  <HotJobComponent img={adobe} item={job} path={path} key={i} />
                ))}
            </div>
          </div>
        </div>
      </section>
      {/* End feature-cat Area */}

      {/* Start feature-cat Area */}
      {companies?.length > 0 && (
        <section className="feature-cat-area pb-100">
          <div className="container">
            <div className="row d-flex justify-content-center">
              <div className="menu-content pb-20 col-lg-10">
                <div className="title text-center">
                  <h1 className="mb-10">Companies That Are Actively Hiring</h1>
                  <p>Equal Opportunities, Limitless Possibilities</p>
                </div>
              </div>
            </div>
            <div className="row">
              {companies?.length > 0 &&
                companies?.map((company, i) => (
                  <CompanyComponent
                    item={company}
                    path={path}
                    img={adobe}
                    key={i}
                  />
                ))}
            </div>
          </div>
        </section>
      )}
      {/* End feature-cat Area */}

      {/* Start callto-action Area */}
      {/* <section className="callto-action-area section-gap" id="join">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="menu-content col-lg-9">
              <div className="title text-center">
                <h1 className="mb-10 text-white">
                  Be You, Be Valued – Explore Open Roles!
                </h1>
                <p className="text-white">
                  Discover job opportunities where your identity is celebrated,
                  and your talents are truly valued!
                  <br />
                  <i>
                    Your identity is safe with us.
                    <br />
                    All our initiatives are exclusive to the LGBT+ community and
                    offered at ZERO fee.
                  </i>
                </p>
                <Link className="primary-btn" to="/login">
                  Register/Login
                </Link>
                <p className="text-white">
                  Not out yet, not sure?
                  <br /> Talk to our expert recruiters Have questions or need
                  guidance? <br /> Reach out to us at{" "}
                  <Link
                    to="mailto:rise@thepridecircle.com"
                    className="text-white"
                  >
                    <i className="fa fa-envelope"></i> rise@thepridecircle.com
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* End calto-action Area */}

      {/* <!-- Start callto-action Area --> */}
      <section className="callto-action-area section-gap" id="join">
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="menu-content col-lg-9">
              <div className="title text-center">
                <h1 className="mb-10 text-white">
                  Be You, Be Valued - Explore Open Roles!
                </h1>
                <p className="text-white">
                  Discover career opportunities where{" "}
                  <b>your individuality is celebrated</b> and{" "}
                  <b>your potential is valued</b> - whether you’re a woman
                  professional or an LGBT+ individual ready to grow, thrive, and
                  lead with pride.
                </p>
                <p className="text-white">
                  Advance your career with companies that lead with equity and
                  belonging.
                </p>
                <Link className="primary-btn" to="/login">
                  Signup as a candidate
                </Link>
                <br />
                <br />
                <p className="text-white">
                  <b>Not sure where to begin?</b>
                  <br />
                  Talk to our expert recruiters for personalized guidance on
                  your career path, applications, and interviews.
                </p>
                <br />
                <p style={{ color: "yellow" }}>
                  <i>
                    <b>
                      Your privacy matters. Your information is safe with us.
                    </b>
                    <br />
                    You can choose how much you wish to share - your information
                    is always handled with complete confidentiality.
                  </i>
                </p>
                <p className="text-white">
                  <b>
                    All our initiatives are designed exclusively for Women and
                    LGBT+ professionals and offered at zero fee.
                  </b>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End calto-action Area -->  */}
    </Fragment>
  );
}
